import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Temperature = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.19 118.69">
  <G fill={color}>
    <Path d="M45.04,18.32C45.04,8.22,36.82,0,26.72,0S8.4,8.22,8.4,18.32v54.22c-5.36,5.04-8.4,12.01-8.4,19.43,0,14.73,11.99,26.72,26.72,26.72s26.72-11.99,26.72-26.72c0-7.42-3.04-14.39-8.4-19.43V18.32ZM26.72,110.01c-9.95,0-18.04-8.09-18.04-18.04,0-5.49,2.47-10.62,6.77-14.07,1.03-.82,1.62-2.07,1.62-3.39V18.32c0-5.31,4.32-9.64,9.64-9.64s9.64,4.32,9.64,9.64v56.19c0,1.32.6,2.56,1.62,3.39,4.3,3.45,6.77,8.58,6.77,14.07,0,9.95-8.09,18.04-18.04,18.04Z"/>
    <Path d="M31.06,82.12v-43.38c0-2.4-1.94-4.34-4.34-4.34s-4.34,1.94-4.34,4.34v43.38c-3.78,1.67-6.42,5.45-6.42,9.85,0,5.94,4.82,10.76,10.76,10.76s10.76-4.82,10.76-10.76c0-4.4-2.64-8.18-6.42-9.85Z"/>
    <Path d="M54.19,15.25h1.67c2.4,0,4.34-1.94,4.34-4.34s-1.94-4.34-4.34-4.34h-1.67c-2.4,0-4.34,1.94-4.34,4.34s1.94,4.34,4.34,4.34Z"/>
    <Path d="M55.85,23.56h-1.67c-2.4,0-4.34,1.94-4.34,4.34s1.94,4.34,4.34,4.34h1.67c2.4,0,4.34-1.94,4.34-4.34s-1.94-4.34-4.34-4.34Z"/>
    <Path d="M55.85,40.54h-1.67c-2.4,0-4.34,1.94-4.34,4.34s1.94,4.34,4.34,4.34h1.67c2.4,0,4.34-1.94,4.34-4.34s-1.94-4.34-4.34-4.34Z"/>
    <Path d="M55.85,57.52h-1.67c-2.4,0-4.34,1.94-4.34,4.34s1.94,4.34,4.34,4.34h1.67c2.4,0,4.34-1.94,4.34-4.34s-1.94-4.34-4.34-4.34Z"/>
  </G>
</Svg>
);
};

export default Temperature;
